module.exports = __webpack_public_path__ + "static/media/linkLogo.5d603cf7.jpeg";